<div class="background-logo">
  <div id="container-saiba-mais">
    <div id="container-btn-saiba-mais-logo">
      <img src="../../../../assets/homePage/ic_saiba_mais.svg" alt="Role para saber mais" />
    </div>
    <span>Role para saber mais</span>
  </div>
</div>
@if (sobreSistema) {
  <div id="container-descricao-ecossistema">
    <div id="texto-descricao-ecossistema-conteudo" [innerHTML]="sobreSistemaDescricao"></div>
  </div>
}
@if (totalProjRegBr && !isLoadingMapData) {
  <div id="container-mapa">
    <p id="titulo-mapa">
      Ecossistema de Inovação como impulsionador do desenvolvimento regional
    </p>
    <p id="subtitulo-mapa">
      Selecione a região e conheça nossos projetos
    </p>
    <div>
      @if (isZooming) {
        <div fxLayout="column" class="project-content" style="cursor: pointer;">
          <div fxLayout="row" fxLayoutGap="10px">
            <span class="btn-voltar-mapa" fxLayoutAlign="start center" (click)="callZoomOut()">
              <span class="material-icons">
                keyboard_arrow_left
              </span>
              Voltar
            </span>
          </div>
        </div>
      }
      @if (!isZooming) {
        <div style="width: 60px; height: 45px;"></div>
      }
      <div id="container-mapa-qtd-projs">
        <app-qtd-projetos-regioes-br [totalProjRegBr]="totalProjRegBr" id="qtd-projs-container"></app-qtd-projetos-regioes-br>
        <app-mapa-brasil id="mapa-brasil-component"
          style="padding-top: 70px;"
          [totalProjRegBr]="totalProjRegBr"
          (emitIsZooming)="changeZoomIntern($event)"
          [isLogado]="isLogado"
        [changingZoom]="changingZoom"></app-mapa-brasil>
      </div>
    </div>
  </div>
}
@if (isLoadingMapData) {
  <div>
    <app-loading-spinner [diameter]="20"></app-loading-spinner>
  </div>
}
<div id="vertentes-container">
  <div id="container-texto-vertentes">
    <p id="titulo-vertentes">Vertentes do Ecossistema de Inovação</p>
    <p id="subtitulo-vertentes">De acordo com a metodologia do Sebrae, entende-se por vertentes grupos com naturezas, caraterísticas e propósitos semelhantes que compõem um ecossistema.</p>
  </div>
  <app-card-vertente-info-public [vertentes]="vertentes"></app-card-vertente-info-public>
</div>
<div id="containter-timings">
  <div id="content-timings">
    <p id="titulo-timings"><span>Timings</span> do Projeto</p>
    <div id="content-itens">
      <app-card-timing-info-public [timings]="timings"></app-card-timing-info-public>
    </div>
  </div>
</div>
<div id="container-ciclo-recompensa" fxLayout="row">
  <div id="ciclo-folder-container" fxFlex="42">
    <p id="label-folder-ciclo-recompensa">
      Impacto na cultura de inovação
    </p>
  </div>
  <div id="ciclo-descricao" fxFlex="58">
    <p id="texto-ciclo-recompensa">
      A abordagem de Ecossistemas Locais de Inovação (ELI) busca compreender de maneira sistêmica o ecossistema de inovação de um município ou de uma microrregião geográfica, considerando suas vocações econômicas e seu potencial tecnológico, para promover o desenvolvimento local, sob a ótica da inovação, e estruturar uma intervenção coordenada de longo prazo.
      <br/><br/>
      O ELI tem como objetivo principal aumentar o grau de maturidade do ecossistema de inovação local. Para isso é fundamental ampliar a efetividade das integrantes das vertentes, ou seja, melhorar a entrega de valor de cada uma delas, bem como ampliar a integração entre as instituições – criar uma dinâmica de diálogo e de cooperação coletiva.
    </p>
  </div>
</div>
<div id="container-ciclo">
  <div id="container-texto-ciclo" class="ciclo-flex-item">
    <p id="titulo-ciclo">Ciclo virtuoso de promoção do desenvolvimento local sob a ótica da inovação</p>
  </div>
  <div id="container-grafico-ciclo">
    <img class="ciclo-flex-item pointer" id="grafico-ciclo"
      src="../../../../assets/homePage/etapas_implementacao_metodologias.jpg"
      alt="Etapas de Implantacao da Metodologia em um Ecossistema de Inovação"
      title="Etapas de Implantacao da Metodologia em um Ecossistema de Inovação"
      (click)="irParaSaibaMaisPassosImplantacao()">
  </div>
</div>
